import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoShort = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 22 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.6173 8.33765V25H16.2315V13.2712L20.6173 8.33765Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.38592 20.4182L0.00012207 15.9731V24.9996H4.38592V20.4182Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 22,
			height: 19,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0H21.2271V18.7608H0V0Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.22858 12.3496L-0.00012207 5.03349V11.4267L7.24014 18.7608L21.227 3.03675V0L7.22858 12.3496Z",
				fill: "#FA6450"
			})
		})
	]
});
export default SvgLogoShort;
